export default "__VITE_ASSET__B3A_AEbu__"